import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/NewLiveValueWallbox.svg"

const NewLiveValueWallbox: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 80 80'} component={Icon} {...props} fill="currentColor" />
export default NewLiveValueWallbox
